import { Spin } from 'antd'
import React from 'react'

function LoadingSpinner() {
  return (
    <Spin className='primary' />
  )
}

export default LoadingSpinner